import { render, staticRenderFns } from "./PageBuilderCtaWidget.vue?vue&type=template&id=55e48f5c&scoped=true"
import script from "./PageBuilderCtaWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderCtaWidget.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderCtaWidget.vue?vue&type=style&index=0&id=55e48f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e48f5c",
  null
  
)

export default component.exports